/**
 * The FinalCTASection presets, as plain data.
 *
 * Kept out of the component so the tracking inventory (src/lib/trackingTaxonomy.ts)
 * can list the banner button labels without importing a React component -- and so
 * the labels it lists are the ones actually rendered, not a copy that can drift.
 */
export type CTAVariant = 'demo' | 'trial' | 'contact' | 'pricing';

export interface CTAPreset {
  title: string;
  subtitle: string;
  ctaText: string;
  ctaLink: string;
  secondaryText: string;
  secondaryLink: string;
}

export const CTA_PRESETS: Record<CTAVariant, CTAPreset> = {
  demo: {
    title: 'Ready to see Hirebee HRMS in action?',
    subtitle: 'Book a personalized demo and discover how we can transform your HR operations.',
    ctaText: 'Schedule Demo',
    ctaLink: '/demo',
    secondaryText: 'View Features',
    secondaryLink: '/features',
  },
  trial: {
    title: 'Start your free trial today',
    subtitle: 'Join 1,000+ companies using Hirebee HRMS. No credit card required.',
    ctaText: 'Start Free Trial',
    ctaLink: '/pricing',
    secondaryText: 'View Pricing',
    secondaryLink: '/pricing',
  },
  contact: {
    title: "Have questions? We're here to help",
    subtitle: 'Get personalized guidance from our HR technology experts.',
    ctaText: 'Contact Sales',
    ctaLink: '/contacts',
    secondaryText: 'Call Us',
    secondaryLink: 'tel:+14708099036',
  },
  pricing: {
    title: 'See how much you can save',
    subtitle: 'Compare our plans and find the perfect fit for your team size.',
    ctaText: 'View Pricing',
    ctaLink: '/pricing',
    secondaryText: 'Calculate ROI',
    secondaryLink: '/pricing#calculator',
  },
};
